import { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actionCreators from "./actions/thunks";
import TextButton from "@shared/v2/TextButton";
import Button from "@shared/v2/Button/Button";
import BlueprintAccessModal from "./BlueprintAccessModal";

const TitleAndEscrowCard = ({ type, sendBlueprintRequest, listingId, dismissCard, isBlueprintOnboarded }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const showModal = () => {
    setModalOpen(true);
  };
  const onHideHandlr = () => {
    setModalOpen(false);
  };
  const onGetAccess = () => {
    if (isModalOpen) {
      setModalOpen(false);
    }
    sendBlueprintRequest(listingId);
  };
  const onDismiss = () => {
    dismissCard(listingId);
  };
  return (
    <>
      <div
        className={`tw-border-solid tw-border-[1px] tw-border-neutral-gray-10 tw-shadow-card tw-bg-white tw-flex-none tw-flex tw-flex-col tw-px-[15px] tw-py-[13px] tw-rounded-[8px] `}
      >
        <div className="tw-text-14 tw-font-semibold tw-leading-20px tw-text-gray-75 tw-flex">
          Open title directly from Brivity!
        </div>
        <div className="tw-text-14 tw-font-normal tw-leading-20px tw-text-gray-75 tw-flex">
          {type === "buyer"
            ? "Upload your signed purchase and sale agreement to get started."
            : "Upload an executed Purchase and Sale Agreement or initiate a pre-contract title search."}
        </div>
        <div className="tw-pt-[12px]">
          <img
            className="tw-block tw-w-full tw-h-full tw-object-cover"
            src="/assets/hand-over-doc.png"
            alt="Hand Over Document"
          />
        </div>
        <div className="tw-pt-[12px] tw-flex tw-justify-between">
          <TextButton size="small" onClick={isBlueprintOnboarded ? onDismiss : showModal}>
            {isBlueprintOnboarded ? "Dismiss" : "Learn More"}
          </TextButton>
          <Button size="small" schema="secondary" onClick={isBlueprintOnboarded ? showModal : onGetAccess}>
            {isBlueprintOnboarded ? "Learn More" : "Get started"}
          </Button>
        </div>
      </div>
      {isModalOpen && (
        <BlueprintAccessModal
          isBlueprintOnboarded={isBlueprintOnboarded}
          isModalOpen={isModalOpen}
          onHideHandlr={onHideHandlr}
          onGetAccess={onGetAccess}
        />
      )}
    </>
  );
};

TitleAndEscrowCard.propTypes = {
  sendBlueprintRequest: PropTypes.func,
  dismissCard: PropTypes.func,
  type: PropTypes.string,
  isBlueprintOnboarded: PropTypes.bool,
  listingId: PropTypes.number.isRequired,
};

TitleAndEscrowCard.defaultProps = {
  sendBlueprintRequest: () => {},
  dismissCard: () => {},
  type: null,
  isBlueprintOnboarded: false,
};

const mapStateToProps = (state) => ({
  type: state.tdpDetailsReducer.headerDetails.type,
  listingId: state.tdpDetailsReducer.headerDetails.listing_id,
});

const mapDispatchToProps = (dispatch) => ({
  sendBlueprintRequest: (listingId) => dispatch(actionCreators.sendBlueprintRequest(listingId)),
  dismissCard: (listingId) => dispatch(actionCreators.dismissCard(listingId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TitleAndEscrowCard);
